import {
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  OrderedList,
} from '@chakra-ui/react';
import React from 'react';
import Player from '../../classes/Player';
import useMaybeVideo from '../../hooks/useMaybeVideo'
import PlayerName from '../SocialSidebar/PlayerName';


type LeaderboardModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  leaderboard: Player[];
}

/**
   * Modal that handles showing the leaderboard for the top players' TicTacToeStats
   * @param param0 LeaderboardModalProps to hand into the modal
   * @returns JSX representation of the modal
   */
export default function LeaderboardModal({ isOpen, closeModal, leaderboard }: LeaderboardModalProps): JSX.Element {
  const video = useMaybeVideo()

  leaderboard.sort((a, b) => {
    // Win = 3pts
    // Tie = 1pt
    // Loss = 0pt
    const aStats = a.ticTacToeStats;
    const bStats = b.ticTacToeStats;

    const aPoints = aStats.wins * 3 + aStats.ties;
    const bPoints = bStats.wins * 3 + bStats.ties;

    return bPoints - aPoints;
  });
  let leaders = leaderboard;
  if (leaderboard.length > 5) {
    leaders = leaderboard.slice(0, 5);
  }

  return (
    <Modal isOpen={isOpen} onClose={() => { closeModal(); video?.unPauseGame() }}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Top 5 Tic Tac Toe Players</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <OrderedList>
            {leaders.map(player => (
              <ListItem key={player.id}>
                <PlayerName player={player} />
                <div>
                  <h3>Wins: {player.ticTacToeStats.wins} &nbsp;&nbsp; Losses: {player.ticTacToeStats.losses} &nbsp;&nbsp; Ties: {player.ticTacToeStats.ties}</h3>
                </div>
              </ListItem>
            ))}
          </OrderedList>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

